// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-2e63f3da]{margin-top:80px}@media screen and (max-width:959px){.banner[data-v-2e63f3da]{margin-top:40px}}.v-main[data-v-2e63f3da]{box-shadow:0 15px 35px rgba(48,50,75,.03);margin:0 auto;width:1440px}.the-footer--no-banner[data-v-2e63f3da]{margin-top:80px}@media screen and (max-width:959px){.the-footer--no-banner[data-v-2e63f3da]{margin-top:40px}}", ""]);
// Exports
module.exports = exports;
